import { MDText } from 'i18n-react';

import Texts from '../../texts.json';

const LocalT = new MDText(Texts);

export const formatPhoneNumber = (number?: string, allowDefaultNumber = true) => {
  if (!number && !allowDefaultNumber) {
    return { number: '', pretty: '' };
  }

  const internationalRegex = /^(\+44|0044)/;
  const phoneNumber = number || LocalT.translate('buyers.motorway.landlineNumber') as string;
  let phoneNumberNoSpaces = phoneNumber.replace(/ /g, '');
  let formattedPhoneNumber = '';

  const isInternational = phoneNumberNoSpaces.match(internationalRegex)?.[0];

  if (isInternational) {
    phoneNumberNoSpaces = phoneNumberNoSpaces.replace(internationalRegex, '0');
  }

  switch (true) {
  case phoneNumberNoSpaces.startsWith('03'):
  case phoneNumberNoSpaces.startsWith('08'):
  case phoneNumberNoSpaces.startsWith('09'):
  case phoneNumberNoSpaces.startsWith('011'):
    formattedPhoneNumber = `${phoneNumberNoSpaces.substring(0, 4)} ${phoneNumberNoSpaces.substring(4, 7)} ${phoneNumberNoSpaces.substring(7)}`;
    break;
  case phoneNumberNoSpaces.startsWith('02'):
  case phoneNumberNoSpaces.startsWith('055'):
  case phoneNumberNoSpaces.startsWith('056'):
    formattedPhoneNumber = `${phoneNumberNoSpaces.substring(0, 3)} ${phoneNumberNoSpaces.substring(3, 7)} ${phoneNumberNoSpaces.substring(7)}`;
    break;
  case phoneNumberNoSpaces.startsWith('07'):
    formattedPhoneNumber = `${phoneNumberNoSpaces.substring(0, 5)} ${phoneNumberNoSpaces.substring(5, 8)} ${phoneNumberNoSpaces.substring(8)}`;
    break;
  default:
    formattedPhoneNumber = phoneNumberNoSpaces;
    break;
  }

  if (isInternational) {
    formattedPhoneNumber = formattedPhoneNumber.replace(/^0/, `${isInternational} `);
  }

  return {
    number: phoneNumberNoSpaces,
    pretty: formattedPhoneNumber,
  };
};
